import React from 'react';
import Std_Div from './Std_Div';
import '../../CommonCSS/SocietyCSS.css'

const Std_DivApp = () => {
  return (
    // <div className="App">
    //   <Common_Mst />
    // </div>
    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5>Standard Division Definition</h5>
          </div>
        </div>
        <Std_Div/>
      </div>
    </div >
  );
};

export default Std_DivApp;
